module.exports = __webpack_public_path__ + "img/download-on-play-store.1e91d02c.png";